import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const Badge = ({ children, icon, color = 'blue', className = '' }) => {
  const colorStyles = {
    blue: 'border-brand-blue/30 bg-brand-blue/10 text-brand-blue',
    red: 'border-brand-red/30 bg-brand-red/10 text-brand-red uppercase tracking-widest text-[10px]',
    gray: 'border-white/10 bg-white/5 text-gray-300 uppercase tracking-widest text-[10px]',
  };

  return (
    <div style={{
      fontSize: '11px'
    }} className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full border text-sm font-medium ${colorStyles[color]} ${className}`}>
      {icon && <SafeIcon icon={icon} className="text-current" />}
      {children}
    </div>
  );
};

export default Badge;